<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpAguarde"></Aguarde>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h2 class="card-title">Competência</h2>
                <p class="card-title-desc"></p>
              </div>
            </div>
            <Loader :loading="httpSend">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Mês/Ano" label-for="competencia">
                    <input class="form-control" id="competencia" disabled="true"
                           v-bind:value="dados.competencia"/>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Empresas aptas" label-for="empresas">
                    <input class="form-control" id="empresas" disabled="true"
                           v-bind:value="dados.empresas.empresas"/>
                  </b-form-group>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <button type="button" @click="confirmacao"
                          :disabled="dados.empresas.empresas && dados.empresas.empresas<1"
                          class="btn btn-label btn-success mt-3"><i
                      class="bx bx-bar-chart-square label-icon"></i>
                    Realizar fechamento
                  </button>
                </div>
              </div>
            </Loader>
            <div v-show="list_empresas && list_empresas.length > 0" class="row">
              <div class="col-md-12">
                <table class="table table-centered table-nowrap">
                  <thead class="thead-light">
                  <tr>
                    <th>Empresa¹</th>
                    <th class="text-center">Competencia</th>
                    <th class="text-center">Retenção</th>
                    <th class="text-right">Base de calculo</th>
                    <th class="text-right">Valor devido</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="e in list_empresas" :key="e.ot_dms_codigo">
                    <td>
                        <span class="text-body font-weight-bold">
                          {{ e.ot_pes_nome }}
                        </span>
                    </td>
                    <td class="text-center">
                      {{ e.ot_mes_ref }}/{{ e.ot_ano_ref }}
                    </td>
                    <td class="text-center">
                      {{ e.ot_iss_retido | s_NtoText }}
                    </td>
                    <td class="text-right">
                      {{ e.ot_dms_basetributavel | formatNumeroBr }}
                    </td>
                    <td class="text-right">
                      {{ e.ot_dms_valordevido | formatNumeroBr }}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <span>¹Apenas as empresas com guias disponíveis para pagamento, exceto Simples e MEI, estão sendo exibidos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Aguarde from "@/components/widgets/aguarde";
import Loader from "@/components/widgets/loader";
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {getFechamentoMensal, setFechamentoMensal} from "@/api/admin/gestao/fechamento";
import Swal from "sweetalert2";
import {notifyErro, notifySucesso} from "@/helps/notificacao";

export default {
  page: {
    title: "Fechamento mensal",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    Loader
  },
  data() {
    return {
      title: "Fechamento mensal",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Fechamento mensal',
          active: true,
        },
      ],
      httpSend: false,
      httpAguarde: false,
      dados: {
        competencia: '',
        empresas: 0
      },
      list_empresas: [],
    };
  },
  created() {
    this.getEntidade();
  },
  methods: {
    getEntidade() {
      this.httpSend = true;
      getFechamentoMensal().then(response => {
        if (response.status) {
          this.dados = response.dados;
        } else {
          notifyErro("Erro Interno", "Não foi possível listar as empresas.")
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    confirmacao() {
      Swal.fire({
        title: "Deseja realizar o fechamento",
        text: "O fechamento não poderá ser desfeito",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.salvar();
        }
      });
    },
    salvar() {
      this.httpAguarde = true;
      setFechamentoMensal(this.dados).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.list_empresas = response.dados;
          this.getEntidade();
        } else {
          notifyErro("Erro Interno", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro Interno", error)
      }).finally(() => {
        this.httpAguarde = false
      })
    }
  }
};
</script>


